var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.label
        ? _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._l(_vm.items, function (item) {
        return _c("w-radio", {
          key: item.value,
          attrs: { checked: _vm.value == item.value, label: item.text },
          on: {
            input: function ($event) {
              return _vm.onInput(item.value)
            },
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }